<template>
  <div
    class="font-primary font-medium text-[17px] text-gray-800 pb-6 border-b border-[#DFDFDF]"
  >
    Account security
  </div>
  <SettingsRow class="h-auto py-6">
    <template #left>
      <div>
        <div class="mb-1">Password</div>
        <div class="text-[13px] opacity-50">
          Set a unique password to protect your Dacr account.
        </div>
      </div>
    </template>
    <template #right>
      <div
        class="font-medium text-[14px] text-green-700 cursor-pointer text-right"
        @click="handleChangePasswordClick"
      >
        Change password
      </div>
    </template>
  </SettingsRow>
</template>

<script setup lang="ts">
import SettingsRow from '@/features/settings/components/SettingsRow.vue'
import { useHead } from '@unhead/vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'

useHead({ title: 'Security - Dacr' })

const dialog = useDialog()

const handleChangePasswordClick = () => {
  dialog.open(Dialogs.ChangePassword)
}
</script>
